export const browserSupportsRequestFullscreenOnDiv = (
  swicthToFullscreenElement: HTMLDivElement,
) => {
  return swicthToFullscreenElement.requestFullscreen !== undefined;
};

export const toggleFullscreenWithRequestFullscreen = (
  swicthToFullscreenElement: HTMLDivElement,
): void => {
  if (!document.fullscreenElement) {
    swicthToFullscreenElement.requestFullscreen();
    return;
  }

  document.exitFullscreen();
};
